import { render, staticRenderFns } from "./SpecialInitiativesSubjectSelector.vue?vue&type=template&id=dee2ae22&scoped=true&"
import script from "./SpecialInitiativesSubjectSelector.vue?vue&type=script&lang=ts&"
export * from "./SpecialInitiativesSubjectSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialInitiativesSubjectSelector.vue?vue&type=style&index=0&id=dee2ae22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee2ae22",
  null
  
)

export default component.exports